<div class="contact-content">
    <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
        <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
    </div>
    <div class="text-container">
        <div class="text">
            <b>Vágólapra helyezés, törlése</b>
        </div>
    </div>
    <div class="container">
        <div class="image-container">
            <div class="image-src" *ngFor="let downloadUri of downloadFileUriList">
                <a [href]="downloadUri"><img [src]="downloadUri" /></a>
                <div class="icons">
                    <img (click)="showToastMessage(downloadUri)" [cdkCopyToClipboard]="downloadUri" class="icon"
                        src="./assets/images/icons8-copy-to-clipboard-48.png" />
                    <mat-icon (click)="openDeleteFilePopup(downloadUri)">delete_forever</mat-icon>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="field-container">
            <div class="field">
                <b>Kép, vagy pdf, docx feltöltése * (.jpg, .png vagy pdf, docx)</b>
                <div class="data">
                    <div class="image-container">
                        <button [ngStyle]="{ background: 'lightgrey' }"
                            onclick="document.getElementById('file').click()">
                            Kiválasztás
                        </button>
                        <span *ngIf="uploadCoverFile">{{ fileCover?.name }}</span>
                        <mat-icon (click)="clearSelectedCoverFile()">delete_forever</mat-icon>
                        <input [ngStyle]="{ display: 'none' }" id="file" #fileCoverInput class="form-control"
                            type="file" (change)="onChange($event)" />
                    </div>
                </div>
                <div class="field-container">
                    <div class="field">
                        <div class="data">
                            <div class="image-container">
                                <button [ngStyle]="{ background: 'lightgrey' }" (click)="uploadFile()">Mentés</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>